import { Controller } from "stimulus";

// Routes a form submit through the form's confirmation modal (forms--confirmation) only when
// this submit is what turns the watched switch on. A submit raised while the modal is open can
// only be its Confirm button, so that one goes through; any other submit, including implicit
// submission (Enter in a field, whose default button is the modal's Confirm because the modal
// renders first in the form), is intercepted. Used by IT Settings > Security for the Share Link
// Signature Image Override.
//
// "Turning on" is judged against the setting as stored, which the form carries as the enabled
// value, not against the switch's state when the page connected: a query string or the
// browser's form restoration can tick the switch before then.
export default class extends Controller {
  static get targets() {
    return ["switch"];
  }

  static get values() {
    return { enabled: Boolean };
  }

  confirm(event) {
    if (!this.enabling || this.modalOpen) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    this.confirmationController.openModal();
  }

  get enabling() {
    return this.switchTarget.checked && !this.enabledValue;
  }

  get modalOpen() {
    return this.confirmationController.materializeModal.isOpen;
  }

  get confirmationController() {
    return this.application.getControllerForElementAndIdentifier(this.element, "forms--confirmation");
  }
}
